import React from 'react';

/**
 * Loading Spinner Component
 * Displays a centered loading spinner with optional text
 */
const LoadingSpinner = ({ text = 'Loading...', fullScreen = false }) => {
  const containerClasses = fullScreen
    ? 'flex flex-col items-center justify-center min-h-screen bg-white dark:bg-gray-900'
    : 'flex flex-col items-center justify-center p-8';

  return (
    <div className={containerClasses}>
      <div className="relative">
        {/* Outer spinning ring */}
        <div className="w-16 h-16 border-4 border-gray-200 dark:border-gray-700 border-t-primary rounded-full animate-spin"></div>

        {/* Inner spinning ring (opposite direction) */}
        <div className="absolute top-0 left-0 w-16 h-16 border-4 border-transparent border-b-accent rounded-full animate-spin-reverse"></div>
      </div>

      {text && (
        <p className="mt-4 text-lg font-medium text-gray-600 dark:text-gray-300 animate-pulse">
          {text}
        </p>
      )}

      <style jsx>{`
        @keyframes spin-reverse {
          from {
            transform: rotate(360deg);
          }
          to {
            transform: rotate(0deg);
          }
        }
        .animate-spin-reverse {
          animation: spin-reverse 1s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner;
